import { connectToSearchCriteriaWithLookupInfo } from "@costar-cosmos/filters-core";
import { LocationsAutoComplete } from "@costar-cosmos/filters-base";
import { mapCriteriaToProps, mapUpdateCriteriaToProps } from "./mappers";

export const LocationFilter = connectToSearchCriteriaWithLookupInfo(
  mapCriteriaToProps,
  mapUpdateCriteriaToProps,
  "sitesLocationFilter"
)(LocationsAutoComplete);

LocationFilter.displayName = "LocationFilter";
